import { AssignMeApi } from 'pripomienky-web-ts-axios';
import { AxiosRequestConfig } from 'axios';
import Uuid from '../model/Uuid';
import { ClientResponse } from '../model/ClientResponse';
import apiConfiguration from './configuration/apiConfiguration';
import { pripomienkyPrefixPath } from './configuration/apiConfigurationConstants';

const client = new AssignMeApi(apiConfiguration(pripomienkyPrefixPath));
// eslint-disable-next-line import/prefer-default-export
export const assignMe = async (
  type: string,
  year: number,
  index: number,
  uuidList: Array<Uuid>,
  options?: AxiosRequestConfig,
):
  Promise<ClientResponse<void>> => {
  const {
    status,
  } = await client.assignMe(
    type,
    year,
    index,
    uuidList,
    options,
  );
  return {
    responseCode: status,
  };
};
